import { render, staticRenderFns } from "./LinkedinCallback.vue?vue&type=template&id=1b8a1722&"
import script from "./LinkedinCallback.vue?vue&type=script&lang=js&"
export * from "./LinkedinCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports